import { defineRecipe } from '@chakra-ui/react';

export const badgeRecipe = defineRecipe({
  className: 'chakra-badge',
  variants: {
    variant: {
      statusBadge: {}
    }
  }
});
